import { Helmet } from "react-helmet-async";
import {
  Box,
  Button,
  Card,
  Container,
  FormControl,
  Stack,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Edit } from "@mui/icons-material";
import { selectAbility } from "../redux/slices/casl.slice";
import Protected from "../protected/Protected";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar/Scrollbar";
import CustomTable from "../components/data-table/CustomDataTable";
import PlansForm from "../sections/@dashboard/plans/plans.form";
import { useGetTopicsQuery } from "../redux/services/topics.service";
import PushNotification from "../sections/@dashboard/topics/pushNotification.form";
import AddTopics from "../sections/@dashboard/topics/AddTopics.form";

export default function TopicsPage() {
  const ability = useSelector(selectAbility);

  const [openPushNotificationForm, setOpenPushNotificationForm] =
    useState(false);
  const [openAddTopicsForm, setOpenAddTopicsForm] = useState(false);
  const [openUpdatePlansForm, setOpenUpdatePlansForm] = useState(false);

  const [openRow, setOpenRow] = useState(null);

  return (
    <Protected>
      <Helmet>
        <title>Topics</title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Topics
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            {ability.can("post", "push-notification") && (
              <>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:checkmark-fill" />}
                  onClick={() => setOpenPushNotificationForm(true)}
                >
                  Push Notification
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  onClick={() => setOpenAddTopicsForm(true)}
                >
                  Create
                </Button>
              </>
            )}
          </Box>
        </Stack>

        {ability.can("post", "push-notification") && (
          <PushNotification
            open={openPushNotificationForm}
            onClose={() => setOpenPushNotificationForm(false)}
          />
        )}

        {ability.can("post", "create-topic") && (
          <AddTopics
            open={openAddTopicsForm}
            onClose={() => setOpenAddTopicsForm(false)}
          />
        )}

        {ability.can("patch", "update-plan") && (
          <PlansForm
            open={openUpdatePlansForm}
            onClose={() => setOpenUpdatePlansForm(false)}
            openRow={openRow}
            edit
          />
        )}

        <Card>
          <Scrollbar>
            <CustomTable
              canSelect
              useDataQuery={useGetTopicsQuery}
              tableName="Topics"
              searchLabel="Search Topic..."
              searchCols={["Name"]}
              actions={
                ability.can("patch", "update-plan")
                  ? {
                      field: "actions",
                      headerName: "Actions",
                      type: "actions",
                      getActions: ({ row }) => [
                        ability.can("Is", "admin") ? (
                          <GridActionsCellItem
                            key="edit"
                            icon={<Edit />}
                            label="Edit"
                            showInMenu
                            onClick={() => {
                              setOpenRow(row);
                              setOpenUpdatePlansForm(true);
                            }}
                          />
                        ) : null,
                      ],
                    }
                  : null
              }
              extraHeaderField={
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      margin: "0 1rem",
                      gap: "1rem",
                    }}
                  />
                </Box>
              }
            />
          </Scrollbar>
        </Card>
      </Container>
    </Protected>
  );
}
